import {
	StyleSettingsCarouselUploaderActionTypes,
	TStyleSettingsCarouselUploaderAction,
} from './styleSettingsCarouselUploaderActions';
import { IStyleSettingsCarouselUploaderState } from './styleSettingsCarouselUploaderContext';

export const styleSettingsCarouselUploaderReducer = (
	state: IStyleSettingsCarouselUploaderState,
	action: TStyleSettingsCarouselUploaderAction,
): IStyleSettingsCarouselUploaderState => {
	switch (action.type) {
		case StyleSettingsCarouselUploaderActionTypes.SET_CROPPER_SRC:
			return {
				...state,
				cropperSrc: action.payload.src,
			};
		case StyleSettingsCarouselUploaderActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case StyleSettingsCarouselUploaderActionTypes.CHANGE_TYPE_OF_ERROR_MODAL_WINDOW:
			return {
				...state,
				typeOfErrorModalWindow: action.payload.typeOfErrorModalWindow,
			};
		default:
			return state;
	}
};
